export default __webpack_public_path__ + "static/media/7.0b817d66.png";